import { render, staticRenderFns } from "./Charge.vue?vue&type=template&id=f240a1f4&scoped=true&"
import script from "./Charge.vue?vue&type=script&lang=ts&"
export * from "./Charge.vue?vue&type=script&lang=ts&"
import style0 from "./Charge.vue?vue&type=style&index=0&id=f240a1f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f240a1f4",
  null
  
)

export default component.exports